<template>
  <div class="icon-wrapper" @click="$emit('action')">
    <svg :fill="color" :width="width" :height="height">
      <use
        v-bind="{
          'xlink:href': require('@/assets/feather-sprite.svg') + '#' + name,
        }"
      ></use>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: String,
    width: {
      type: [Number, String],
      default: 24,
    },
    thin: {
      type: Boolean,
      default: false,
    },
    color: {
      type: [Number, String],
      default: '#4a4a4a',
    },
    height: {
      type: [Number, String],
      default: 24,
    },
  },
};
</script>

<style scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  color: #4a4a4a;
  /* font-size: 10px; */
  /* font-weight: bold; */
}
</style>
